import { render, staticRenderFns } from "./ContentFilterModal.vue?vue&type=template&id=1968d258&"
import script from "./ContentFilterModal.vue?vue&type=script&lang=js&"
export * from "./ContentFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports